var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import SlTextarea from '@shoelace-style/shoelace/dist/components/textarea/textarea.js';
import { customElement, property } from 'lit/decorators.js';
let ChromedashTextarea = class ChromedashTextarea extends SlTextarea {
    constructor() {
        super(...arguments);
        this.cols = 50;
        this.rows = 10;
        // This is the longest string that a cloud ndb StringProperty seems to accept.
        // Fields that accept a URL list can be longer, provided that each individual
        // URL is no more than this length.
        this.maxlength = 1400;
    }
    /**
     * Checks whether the value conforms to custom validation constraints.
     * @return true if value is valid.
     */
    customCheckValidity(value) {
        if (this.multiple) {
            if (this.chromedash_split_pattern && this.chromedash_single_pattern) {
                const items = value.split(new RegExp(this.chromedash_split_pattern));
                const singleItemRegex = new RegExp('^' + this.chromedash_single_pattern + '$', '');
                const valid = items.every(item => {
                    if (!item) {
                        // ignore empty items
                        return true;
                    }
                    const itemValid = singleItemRegex.test(item);
                    return itemValid;
                });
                if (!valid) {
                    return false;
                }
            }
        }
        // If there is a pattern, and the value doesn't match the pattern, then fail.
        // This applies regardless whether this.multiple is true.
        if (this.pattern) {
            const valueRegex = new RegExp('^' + this.pattern + '$', '');
            return valueRegex.test(value);
        }
        // Otherwise, assume it is valid.  What about required? disabled?
        return true;
    }
    validate() {
        if (this.input === null) {
            return;
        }
        const invalidMsg = this.customCheckValidity(this.input.value)
            ? ''
            : 'invalid';
        if (this.setCustomValidity) {
            this.setCustomValidity(invalidMsg);
        }
    }
    firstUpdated() {
        this.validate();
    }
    updated() {
        if (!this.input) {
            return;
        }
        this.validate();
    }
};
__decorate([
    property({ type: Boolean })
], ChromedashTextarea.prototype, "multiple", void 0);
__decorate([
    property({ type: String })
], ChromedashTextarea.prototype, "pattern", void 0);
__decorate([
    property({ type: String })
], ChromedashTextarea.prototype, "chromedash_single_pattern", void 0);
__decorate([
    property({ type: String })
], ChromedashTextarea.prototype, "chromedash_split_pattern", void 0);
__decorate([
    property({ type: Number })
], ChromedashTextarea.prototype, "cols", void 0);
__decorate([
    property({ type: Number })
], ChromedashTextarea.prototype, "rows", void 0);
__decorate([
    property({ type: Number })
], ChromedashTextarea.prototype, "maxlength", void 0);
ChromedashTextarea = __decorate([
    customElement('chromedash-textarea')
], ChromedashTextarea);
export { ChromedashTextarea };
